import React from "react";
import PropTypes from "prop-types";
import Video from "../../common/Video";
import "./index.scss";

const Testimonials = ({ setUrlYoutubeModal }) => (
  <section className="PgESM-T">
    <h1 className="PgESM-T__title">
      Herramientas para Investigación de Productos en Amazon
    </h1>
    <p className="PgESM-T__subtitle">
      Empoderando a vendedores famosos y residentes de AMZScout
    </p>
    <Video
      setUrlYoutubeModal={setUrlYoutubeModal}
      language="es"
      customClass="PgESM-T-V"
    />
  </section>
);
Testimonials.propTypes = {
  setUrlYoutubeModal: PropTypes.func,
};
export default Testimonials;
